import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class DpInventoryAvailability<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
 * @description Get distributor by token
 *
 * @tags DpInventoryAvailability
 * @name DpInventoryAvailabilityGetAvailability
 * @summary Get distributor by token
 * @request GET:/store/{storeId}/inventory/GetAvailability
 * @secure
 * @response `200` `{
    response?: ({
  \** The buyable. *\
    buyable?: boolean,
  \** The selectedQuantity. *\
    selectedQuantity?: number,
  \** The diff. *\
    diff?: number,
  \** The currentlyAvailable. *\
    currentlyAvailable?: number,
  \** The SKU. *\
    sku?: string,
  \** The catEntryId. *\
    catEntryId?: string,

})[],

}` The requested completed successfully.
 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
 * @response `401` `void` Not authenticated. The user session is not valid.
 * @response `403` `void` The user is not authorized to perform the specified request.
 * @response `500` `void` Internal server error. For details, see the server log files.
 */
	dpInventoryAvailabilityGetAvailability = (
		storeId: string,
		query?: {
			/** The sku. */
			sku?: string;
			/** The orderId. */
			orderId?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['dpInventoryAvailabilityGetAvailability'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/inventory/GetAvailability`,
				params: _params,
				query: query,
				methodName: 'dpInventoryAvailabilityGetAvailability',
			};
			logger.trace(traceData);
		}
		return this.http.request<
			{
				response?: {
					/** The buyable. */
					buyable?: boolean;
					/** The selectedQuantity. */
					selectedQuantity?: number;
					/** The diff. */
					diff?: number;
					/** The currentlyAvailable. */
					currentlyAvailable?: number;
					/** The SKU. */
					sku?: string;
					/** The catEntryId. */
					catEntryId?: string;
				}[];
			},
			void
		>({
			path: `/store/${storeId}/inventory/GetAvailability`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
